var unparam;

module.exports = unparam = function(str) {
  var data, i, keyPairs, keyVal, len, tuple;
  if (str == null) {
    str = location.search;
  }
  if (typeof str !== 'string') {
    throw new TypeError("unparam needs a string, but got " + (JSON.stringify(str)));
  }
  data = {};
  keyPairs = str.replace(/\+/g, '%20').split('&');
  for (i = 0, len = keyPairs.length; i < len; i++) {
    keyVal = keyPairs[i];
    if (!(tuple = /^\??([^=]*)=(.*)/.exec(keyVal))) {
      continue;
    }
    try {
      data[decodeURIComponent(tuple[1])] = decodeURIComponent(tuple[2]);
    } catch (error) {}
  }
  return data;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvZ2VuZXJhbC9tX3VucGFyYW0uY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvZ2VuZXJhbC9tX3VucGFyYW0uY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLElBQUE7O0FBQUEsTUFBTSxDQUFDLE9BQVAsR0FBaUIsT0FBQSxHQUFVLFNBQUMsR0FBRDtBQUN6QixNQUFBOztJQUQwQixNQUFNLFFBQVEsQ0FBQzs7RUFDekMsSUFBTyxPQUFPLEdBQVAsS0FBYyxRQUFyQjtBQUNFLFVBQVUsSUFBQSxTQUFBLENBQVUsa0NBQUEsR0FBa0MsQ0FBQyxJQUFJLENBQUMsU0FBTCxDQUFlLEdBQWYsQ0FBRCxDQUE1QyxFQURaOztFQUVBLElBQUEsR0FBTztFQUVQLFFBQUEsR0FBVyxHQUFHLENBQUMsT0FBSixDQUFZLEtBQVosRUFBbUIsS0FBbkIsQ0FBeUIsQ0FBQyxLQUExQixDQUFnQyxHQUFoQztBQUNYLE9BQUEsMENBQUE7O0lBQ0UsSUFBQSxDQUFnQixDQUFBLEtBQUEsR0FBUSxrQkFBa0IsQ0FBQyxJQUFuQixDQUF3QixNQUF4QixDQUFSLENBQWhCO0FBQUEsZUFBQTs7QUFDQTtNQUFJLElBQUssQ0FBQSxrQkFBQSxDQUFtQixLQUFNLENBQUEsQ0FBQSxDQUF6QixDQUFBLENBQUwsR0FBb0Msa0JBQUEsQ0FBbUIsS0FBTSxDQUFBLENBQUEsQ0FBekIsRUFBeEM7S0FBQTtBQUZGO1NBR0E7QUFUeUIifQ==
